import { forwardRef, Ref, type SVGProps } from 'react';

const SvgAccountIcon = (
  props: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 26 26"
    ref={ref}
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M1 24.167c3.114-3.304 7.343-5.334 12-5.334s8.886 2.03 12 5.334M19 7.5a6 6 0 1 1-12 0 6 6 0 0 1 12 0"
    />
  </svg>
);
const ForwardRef = forwardRef(SvgAccountIcon);
export default ForwardRef;
